import navMock from "@/mock/navigation.json";
import {navParent} from "@/types/navigation";

import {getDataMock} from "./_callApi";

export async function getNavigation(): Promise<navParent[]> {
  if (getDataMock()) {
    const navigation: navParent[] = navMock;
    return navigation;
  } else {
    const navigation: navParent[] = navMock;
    return navigation;
  }
}
